import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./Login";
import Dashboard from "./Dashboard";


// import DashboardConversaations from "./components/Conversations";

import CampaignScreen from "./components/CampaignScreen";
import ClientsScreen from "./components/Clients";
import CarrosAbandonadosScreen from "./components/CarrosAbandonados";
import UserManagment from "./UsersManagement";
import OrdersScreen from "./components/Orders";
import NewClientsScreen from "./components/NewClientsScreen";


import Navbar from "./Navbar";
import NavbarXeroo from "./NavbarXeroo";
import NavbarLeads from "./NavbarXeroo";
import StatsDashboard from "./StatsDashboard";
import FraudCheckScreen from "./components/FraudCheckScreen";
import XerooClientLanding from "./components/Welcome";
import IASearchLanding from "./components/IASearch";
import StatsDailyDashboard from "./dailyConversations";
import { AuthProvider } from "./AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />

                

     <Route
                    path="/abandoned-carts"
                    element={
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <CarrosAbandonadosScreen />
                                <ToastContainer />
                            </div>
                    }
                />



                


                {/* Rutas protegidas */}
                {/* <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <div className="container mx-auto p-4 flex-1">

                                    <DashboardConversaations />
                                </div>
                                <ToastContainer />
                            </div>

                        </ProtectedRoute>
                    }
                /> */}

                {/* <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <div className="container mx-auto p-4 flex-1">
                                    <h2 className="text-2xl font-bold mb-4">Indicadores</h2>
                                    <StatsDashboard />
                                    <hr className="my-8" />
                                    <Dashboard />
                                </div>
                                <ToastContainer />
                            </div>

                        </ProtectedRoute>
                    }
                /> */}



                {/* <Route
                    path="/campaigns"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <CampaignScreen />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                /> */}
              
                {/* <Route
                    path="/users"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <UserManagment />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                /> */}
                <Route
                    path="/orders"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <OrdersScreen />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/new-clients"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <Navbar />
                                <NewClientsScreen />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/iasearch"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                {/* <NavbarXeroo /> */}
                                <IASearchLanding />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/welcome"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLanding />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <div data-theme="light" className="min-h-screen flex flex-col bg-base-200">
                                <XerooClientLanding />
                                <ToastContainer />
                            </div>
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}


